import { captureAbbTrackingFromUrl } from "./tracking/utils";
import { getEnv } from "./utils/getEnv";

if (getEnv() !== "prod") {
  captureAbbTrackingFromUrl();
}
import("./bootstrap");

export {};
